/**
 *  Submenu items for Sister Integration
 */
export default [
  {
    icon: "SettingsIcon",
    menu: "Setting Sister",
    url: "sister-setting",
  },
  {
    icon: "UsersIcon",
    menu: "Data Dosen",
    url: "sister-dosen",
  },
  {
    icon: "DatabaseIcon",
    menu: "Referensi SISTER",
    url: "sister-referensi",
  },
  {
    icon: "AwardIcon",
    menu: "Verifikasi Jafung",
    url: "sister-jafung",
  },
];

